import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Zap, Scale, TrendingDown } from 'lucide-react';
const costData = [{
  without: 'Sin servicio definido',
  cost: 'Meses perdidos sin poder empezar'
}, {
  without: 'Sin perfil optimizado',
  cost: 'Invisible para clientes que buscan'
}, {
  without: 'Sin scripts de propuesta',
  cost: 'El 80% de los proyectos se los lleva otro'
}, {
  without: 'Sin sistema de cierre',
  cost: 'Los prospectos preguntan y desaparecen'
}, {
  without: 'Sin método de cobro',
  cost: 'Perdés clientes internacionales'
}, {
  without: 'Sin clientes recurrentes',
  cost: 'Empezás desde cero cada mes'
}];
export function CostTable() {
  return <section className="py-16 bg-graphite relative overflow-hidden" data-id="element-137">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-danger/5 blur-[120px] rounded-full pointer-events-none" data-id="element-138"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-139">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-140">
          <div className="absolute -inset-1 bg-danger rounded-3xl blur-xl opacity-20" data-id="element-141"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-danger rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-danger/20" data-id="element-142">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,90,90,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,90,90,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-143"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-danger rounded-tl-3xl pointer-events-none" data-id="element-144"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-danger rounded-tr-3xl pointer-events-none" data-id="element-145"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-danger rounded-bl-3xl pointer-events-none" data-id="element-146"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-danger rounded-br-3xl pointer-events-none" data-id="element-147"></div>

            <div className="relative z-10" data-id="element-148">
              <div className="inline-flex items-center gap-2 bg-danger text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-danger/40" data-id="element-149">
                <Scale className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-150" />
                El costo real
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-151">
                <span className="text-white" data-id="element-152">¿Cuánto cuesta </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-danger via-danger to-danger drop-shadow-[0_0_12px_rgba(255,90,90,0.4)]" data-id="element-153">
                  no tenerlo?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-danger to-transparent opacity-70" data-id="element-154"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop table */}
        <div className="max-w-3xl mx-auto mb-10 hidden md:block" data-id="element-155">
          <div className="bg-gradient-to-br from-petroleum to-graphite border border-danger/25 rounded-2xl overflow-hidden shadow-xl shadow-danger/5" data-id="element-156">
            <table className="w-full text-left border-collapse" data-id="element-157">
              <thead data-id="element-158">
                <tr className="bg-graphite/70" data-id="element-159">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest" data-id="element-160">
                    <span className="inline-flex items-center gap-2" data-id="element-161">
                      <span className="w-6 h-6 rounded-md bg-white/5 flex items-center justify-center" data-id="element-162">
                        <TrendingDown className="w-3.5 h-3.5" data-id="element-163" />
                      </span>
                      Sin el MegaPack
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-danger/40 text-danger font-extrabold text-xs uppercase tracking-widest bg-danger/5" data-id="element-164">
                    <span className="inline-flex items-center gap-2" data-id="element-165">
                      <span className="w-6 h-6 rounded-md bg-danger/20 flex items-center justify-center" data-id="element-166">
                        <AlertTriangle className="w-3.5 h-3.5" data-id="element-167" />
                      </span>
                      Costo real
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-168">
                {costData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-169">
                    <td className="p-5 text-white font-medium align-top" data-id="element-170">
                      <span className="inline-flex items-start gap-3" data-id="element-171">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-172">
                          {i + 1}
                        </span>
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-danger font-semibold align-top bg-danger/[0.04] group-hover:bg-danger/[0.08] transition-colors border-l border-danger/20" data-id="element-173">
                      <span className="inline-flex items-start gap-2" data-id="element-174">
                        <AlertTriangle className="w-4 h-4 text-danger shrink-0 mt-0.5" data-id="element-175" />
                        {row.cost}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-3" data-id="element-176">
          {costData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-gradient-to-br from-petroleum to-graphite border border-danger/20 rounded-2xl overflow-hidden shadow-lg" data-id="element-177">
              <div className="px-5 py-3 bg-graphite/60 border-b border-white/10 flex items-center gap-2.5" data-id="element-178">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center" data-id="element-179">
                  {i + 1}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-180">
                  {row.without}
                </p>
              </div>
              <div className="px-5 py-4 bg-danger/[0.06]" data-id="element-181">
                <div className="inline-flex items-center gap-1.5 text-danger text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-182">
                  <AlertTriangle className="w-3 h-3" data-id="element-183" /> Costo real
                </div>
                <p className="text-danger text-sm font-semibold" data-id="element-184">{row.cost}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing quote card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto" data-id="element-185">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-gold/40 via-gold/30 to-gold/40 rounded-2xl blur-lg opacity-40" data-id="element-186"></div>
          <div className="relative bg-gradient-to-br from-petroleum to-graphite border border-gold/40 rounded-2xl p-8 text-center shadow-[0_0_30px_rgba(255,209,102,0.12)]" data-id="element-187">
            <h3 className="text-xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-gold via-gold to-gold leading-snug flex items-center justify-center gap-3 flex-wrap" data-id="element-188">
              <Zap className="w-6 h-6 md:w-7 md:h-7 text-gold fill-gold drop-shadow-[0_0_8px_rgba(255,209,102,0.6)]" data-id="element-189" />
              <span data-id="element-190">
                "El próximo mensaje que enviés puede ser el primero que te
                traiga un cliente en dólares."
              </span>
            </h3>
            <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-60" data-id="element-191"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}